<script setup lang="ts">
  import { provide, useTemplateRef } from 'vue'
  import AgencyModalDeactivate, {
    type ShowDeactivateAgencyModalParams
  } from '../modals/AgencyModalDeactivate.vue'
  import AgencyModalChangeContactInfo, {
    type ShowChangeContactInfoModalParams
  } from '../modals/AgencyModalChangeContactInfo.vue'
  import AgencyModalChangeName, {
    type ShowChangeAgencyNameModalParams
  } from '../modals/AgencyModalChangeName.vue'
  import AgencyModalMove, {
    type ShowMoveAgencyModalParams
  } from '../modals/AgencyModalMove.vue'
  import AgencyModalLinkToOtherCompany, {
    type ShowLinkToOtherCompanyModalParams
  } from '../modals/AgencyModalLinkToOtherCompany.vue'
  import AgencyModalReactivate, {
    type ShowReactivateAgencyModalParams
  } from '../modals/AgencyModalReactivate.vue'
  import { agencyModalsKey } from './agency-modals'

  const modalAgencyDeactivateRef = useTemplateRef('modalAgencyDeactivateRef')
  const modalChangeAgencyContactInfoRef = useTemplateRef(
    'modalChangeAgencyContactInfoRef'
  )
  const modalChangeAgencyNameRef = useTemplateRef('modalChangeAgencyNameRef')
  const modalMoveAgencyRef = useTemplateRef('modalMoveAgencyRef')
  const modalLinkToOtherCompanyRef = useTemplateRef(
    'modalLinkToOtherCompanyRef'
  )
  const modalAgencyReactivateRef = useTemplateRef('modalAgencyReactivateRef')

  const agencyModals = {
    showAgencyDeactivateModal: (params: ShowDeactivateAgencyModalParams) => {
      modalAgencyDeactivateRef.value?.showModal(params)
    },
    showChangeAgencyContactInfoModal: (
      params: ShowChangeContactInfoModalParams
    ) => {
      modalChangeAgencyContactInfoRef.value?.showModal(params)
    },
    showChangeAgencyNameModal: (params: ShowChangeAgencyNameModalParams) => {
      modalChangeAgencyNameRef.value?.showModal(params)
    },
    showMoveAgencyModal: (params: ShowMoveAgencyModalParams) => {
      modalMoveAgencyRef.value?.showModal(params)
    },
    showLinkToOtherCompanyModal: (
      params: ShowLinkToOtherCompanyModalParams
    ) => {
      modalLinkToOtherCompanyRef.value?.showModal(params)
    },
    showReactivateAgencyModal: (params: ShowReactivateAgencyModalParams) => {
      modalAgencyReactivateRef.value?.showModal(params)
    }
  }

  provide(agencyModalsKey, agencyModals)

  defineExpose(agencyModals)
</script>
<template>
  <slot />
  <AgencyModalDeactivate ref="modalAgencyDeactivateRef" />
  <AgencyModalChangeContactInfo ref="modalChangeAgencyContactInfoRef" />
  <AgencyModalChangeName ref="modalChangeAgencyNameRef" />
  <AgencyModalMove ref="modalMoveAgencyRef" />
  <AgencyModalLinkToOtherCompany ref="modalLinkToOtherCompanyRef" />
  <AgencyModalReactivate ref="modalAgencyReactivateRef" />
</template>
